/*
* Pipeline Theme — Custom JS
* Loaded globally on all pages via layout/theme.liquid
*/

(function () {
  'use strict';

  /* ── Intercept theme popdown → open cart drawer instead ── */
  var cartRoot = (window.theme && window.theme.routes && window.theme.routes.cart)
    ? window.theme.routes.cart : '/cart';

  document.addEventListener('theme:cart:popdown', function (e) {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) return;
    e.stopImmediatePropagation();
    drawer.setAttribute('data-sab-entering', '');
    fetch(cartRoot + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
      setTimeout(function () {
        drawer.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        setTimeout(function () {
          var rows = drawer.querySelectorAll('.cart__items__row');
          rows.forEach(function (r) { r.classList.add('cart-animate'); });
          drawer.removeAttribute('data-sab-entering');
        }, 150);
      }, 100);
    });
  }, true);

  /* ── Equalize Flickity carousel slide heights for aligned ATC buttons ── */
  function equalizeFlickitySlides() {
    document.querySelectorAll('.flickity-grid.flickity-enabled').forEach(function (carousel) {
      var viewport = carousel.querySelector('.flickity-viewport');
      if (!viewport) return;
      var h = viewport.getBoundingClientRect().height;
      if (h > 0) {
        carousel.style.setProperty('--flickity-viewport-height', h + 'px');
      }
    });
  }
  // Run after recommendations load + Flickity initializes
  setTimeout(equalizeFlickitySlides, 3000);
  setTimeout(equalizeFlickitySlides, 5000);
  window.addEventListener('resize', function () {
    requestAnimationFrame(equalizeFlickitySlides);
  });

  /* ── Move quick-add toolbar below product info for async-loaded cards ── */
  /* The inline script in product-grid-item.liquid handles cards on initial
     render, but related/recently-viewed products load via the recommendations
     API after DOMContentLoaded, so their toolbars stay inside the image
     container. This observer catches them and moves the toolbar into the
     correct position (after .product__grid__info). */
  var gridObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var items = node.querySelectorAll
          ? node.querySelectorAll('product-grid-item')
          : [];
        items.forEach(function (el) {
          var toolbar = el.querySelector('[class*="quick-actions-toolbar"]');
          var info = el.querySelector('.product__grid__info');
          if (toolbar && info && toolbar.closest('.product-grid-item__container')) {
            info.after(toolbar);
          }
        });
      });
    });
  });
  gridObserver.observe(document.body, { childList: true, subtree: true });

  /* ── App-popup visibility (paired with rules in custom.css) ──
     (A) Tag <body> with .cart-has-items whenever the live cart is non-empty,
         so CSS can hide the Klaviyo "Your first bag ships free" popup.
     (B) Tag <body> with .cart-drawer-open while the cart drawer is open,
         so CSS can hide the Shopify Inbox chat bubble. */

  // (A) Cart item count → body flag.
  function setCartItemsFlag(count) {
    document.body.classList.toggle('cart-has-items', (count || 0) > 0);
  }
  function refreshCartItemsFlag() {
    fetch(cartRoot + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(onCartState)
      .catch(function () {});
  }
  refreshCartItemsFlag(); // authoritative initial state (page HTML may be cached)
  document.addEventListener('theme:cart:change', function (e) {
    if (e.detail && e.detail.cart) onCartState(e.detail.cart);
  });
  // Safety net for any add that skips theme:cart:change: re-pull on reload.
  document.addEventListener('theme:cart:reload', refreshCartItemsFlag);

  /* ── (B) Hide the Shopify Inbox chat bubble while the cart drawer is open ──
     Tag <body> with .cart-drawer-open (paired with a rule in custom.css).
     The theme fires these events on the cart drawer element specifically,
     so opening the nav drawer won't trigger it. */
  var cartDrawerEl = document.querySelector('[data-drawer="drawer-cart"]');
  if (cartDrawerEl) {
    cartDrawerEl.addEventListener('theme:drawer:open', function () {
      document.body.classList.add('cart-drawer-open');
      if (latestCart) { updateRecs(latestCart); } else { refreshCartItemsFlag(); }
    });
    cartDrawerEl.addEventListener('theme:drawer:close', function () {
      document.body.classList.remove('cart-drawer-open');
    });
  }

  /* ── Free shipping progress bar + "Goes well with" recommendations ──
     Drawer-only clone of the Essential Free Shipping Upsell app.
     Threshold comes from the theme's own free-shipping setting
     (settings.free_shipping_limit, exposed on window.theme.settings). */

  var FS_LIMIT_CENTS = (function () {
    var raw = window.theme && window.theme.settings && window.theme.settings.free_shipping_limit;
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : Math.round(n * 100);
  })();
  var rootUrl = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
  if (rootUrl.slice(-1) !== '/') rootUrl += '/';

  var latestCart = null;
  var lastItemsSig = null;
  var recsCache = {};   // seed product id -> candidate list; cleared on any cart mutation

  function fmtMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── Progress bar ── */
  function getShipBar() {
    if (!cartDrawerEl || FS_LIMIT_CENTS <= 0) return null;
    var bar = document.getElementById('ka-shipbar');
    if (bar) return bar;
    var top = cartDrawerEl.querySelector('.drawer__top');
    if (!top) return null;
    bar = document.createElement('div');
    bar.id = 'ka-shipbar';
    bar.className = 'ka-shipbar';
    bar.setAttribute('hidden', '');
    bar.setAttribute('aria-live', 'polite');
    bar.innerHTML =
      '<p class="ka-shipbar__text" data-ka-shipbar-text></p>' +
      '<div class="ka-shipbar__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-label="Free shipping progress" data-ka-shipbar-track>' +
        '<span class="ka-shipbar__fill" data-ka-shipbar-fill></span>' +
      '</div>';
    top.after(bar);
    return bar;
  }

  function updateShipBar(cart) {
    var bar = getShipBar();
    if (!bar) return;
    if (!cart || !cart.item_count) {
      bar.setAttribute('hidden', '');
      return;
    }
    var total = cart.total_price;
    var remaining = FS_LIMIT_CENTS - total;
    var pct = Math.min(100, Math.round((total / FS_LIMIT_CENTS) * 100));
    var text = bar.querySelector('[data-ka-shipbar-text]');
    text.textContent = remaining > 0
      ? "You're " + fmtMoney(remaining) + ' away from free shipping'
      : "You've unlocked free shipping";
    bar.classList.toggle('ka-shipbar--unlocked', remaining <= 0);
    bar.querySelector('[data-ka-shipbar-fill]').style.width = pct + '%';
    bar.querySelector('[data-ka-shipbar-track]').setAttribute('aria-valuenow', pct);
    bar.removeAttribute('hidden');
  }

  /* ── Recommendations ("Goes well with") ── */
  var SIZE_250_RE = /^250\s?g$/i;
  var COFERM_RE = /co-?ferment/i;

  function currentPdpHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  // Normalize a product from either the recommendations API (.js money-in-cents
  // format) or /collections/x/products.json (string-dollar format) into one shape.
  function normalizeProduct(p, fromCollectionJson) {
    var variants = p.variants || [];
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (SIZE_250_RE.test(variants[i].title || '')) { v = variants[i]; break; }
    }
    if (!v) return null;
    var priceCents = fromCollectionJson
      ? Math.round(parseFloat(v.price) * 100)
      : v.price;
    var image = fromCollectionJson
      ? (p.images && p.images[0] && p.images[0].src)
      : (p.featured_image || null);
    return {
      productId: p.id,
      handle: p.handle,
      title: p.title,
      url: rootUrl + 'products/' + p.handle,
      image: image,
      variantId: v.id,
      priceCents: priceCents,
      available: v.available, // may be undefined; verified before render
      coferm: COFERM_RE.test(p.title || '')
    };
  }

  // The availability filter must run on the variant we would add. If the source
  // endpoint didn't include the field, confirm via the product's own .js endpoint.
  function verifyAvailability(candidate) {
    if (candidate.available === true) return Promise.resolve(candidate);
    if (candidate.available === false) return Promise.resolve(null);
    return fetch(rootUrl + 'products/' + candidate.handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var v = (p.variants || []).find(function (v) { return v.id === candidate.variantId; });
        return v && v.available ? candidate : null;
      })
      .catch(function () { return null; });
  }

  function fetchTier1(seedProductId) {
    return fetch(rootUrl + 'recommendations/products.json?product_id=' + seedProductId + '&limit=6&intent=complementary')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        return (data.products || []).map(function (p) { return normalizeProduct(p, false); }).filter(Boolean);
      })
      .catch(function () { return []; });
  }

  function fetchTier2() {
    return fetch(rootUrl + 'collections/best-sellers/products.json?limit=12')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        return (data.products || []).map(function (p) { return normalizeProduct(p, true); }).filter(Boolean);
      })
      .catch(function () { return []; });
  }

  function getRecsContainer() {
    if (!cartDrawerEl) return null;
    var el = document.getElementById('ka-recs');
    if (el) return el;
    var form = cartDrawerEl.querySelector('[data-cart-form]');
    if (!form) return null;
    el = document.createElement('div');
    el.id = 'ka-recs';
    el.className = 'ka-recs';
    el.setAttribute('hidden', '');
    el.innerHTML = '<p class="ka-recs__heading">Goes well with</p><div class="ka-recs__list" data-ka-recs-list></div>';
    form.after(el);
    el.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ka-recs-add]');
      if (btn) addRecToCart(btn);
    });
    return el;
  }

  function hideRecs() {
    var el = document.getElementById('ka-recs');
    if (el) {
      el.setAttribute('hidden', '');
      el.classList.remove('is-ready');
    }
  }

  function updateRecs(cart) {
    var container = getRecsContainer();
    if (!container) return;
    if (!cart || !cart.item_count) {
      hideRecs();
      return;
    }
    var seed = cart.items[0].product_id; // most recent addition
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var pdpHandle = currentPdpHandle();
    var token = String(seed);
    container.dataset.kaPending = token;

    var candidatesPromise = recsCache[seed]
      ? Promise.resolve(recsCache[seed])
      : fetchTier1(seed).then(function (tier1) {
          var passing = tier1.filter(function (c) { return c.available !== false; });
          if (passing.length >= 2) return tier1;
          return fetchTier2().then(function (tier2) {
            var seen = {};
            var merged = tier1.concat(tier2).filter(function (c) {
              if (seen[c.productId]) return false;
              seen[c.productId] = true;
              return true;
            });
            return merged;
          });
        }).then(function (list) {
          recsCache[seed] = list;
          return list;
        });

    candidatesPromise
      .then(function (candidates) {
        var eligible = candidates.filter(function (c) {
          return inCart.indexOf(c.productId) === -1 && c.handle !== pdpHandle;
        });
        return Promise.all(eligible.map(verifyAvailability));
      })
      .then(function (verified) {
        // A newer render may have started while we were fetching.
        if (container.dataset.kaPending !== token) return;
        var survivors = verified.filter(Boolean);
        // Soft preference: co-ferments first (stable sort), then take two.
        survivors.sort(function (a, b) { return (a.coferm ? 0 : 1) - (b.coferm ? 0 : 1); });
        var picks = survivors.slice(0, 2);
        if (picks.length < 2) {
          hideRecs(); // never show a single lonely recommendation
          return;
        }
        renderRecs(container, picks);
      })
      .catch(hideRecs);
  }

  function recImageUrl(src) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=112';
  }

  function renderRecs(container, picks) {
    var list = container.querySelector('[data-ka-recs-list]');
    list.innerHTML = picks.map(function (c) {
      return '<div class="ka-recs__row">' +
        (c.image
          ? '<img class="ka-recs__img" src="' + recImageUrl(c.image) + '" alt="" width="56" height="56" loading="lazy">'
          : '<span class="ka-recs__img"></span>') +
        '<div class="ka-recs__info">' +
          '<p class="ka-recs__title">' + escapeHtml(c.title) + '</p>' +
          '<p class="ka-recs__price">' + fmtMoney(c.priceCents) + '</p>' +
        '</div>' +
        '<button type="button" class="ka-recs__btn" data-ka-recs-add="' + c.variantId + '" aria-label="Add ' + escapeHtml(c.title) + ' to cart">Add</button>' +
      '</div>';
    }).join('');
    container.removeAttribute('hidden');
    requestAnimationFrame(function () { container.classList.add('is-ready'); });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  // One-tap add: drawer stays open; a single pass updates line items,
  // subtotal, progress bar, and recommendation visibility.
  function addRecToCart(btn) {
    var variantId = parseInt(btn.getAttribute('data-ka-recs-add'), 10);
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch(cartRoot + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch(cartRoot + '.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add';
      });
  }

  /* ── Shared cart-state handler: flag + bar + recs in one place ── */
  function onCartState(cart) {
    latestCart = cart;
    setCartItemsFlag(cart.item_count);
    updateShipBar(cart);
    var sig = (cart.items || []).map(function (i) { return i.id + 'x' + i.quantity; }).join(',');
    if (sig !== lastItemsSig) {
      lastItemsSig = sig;
      recsCache = {}; // invalidate on any cart mutation
    }
    if (document.body.classList.contains('cart-drawer-open')) {
      updateRecs(cart);
    } else if (!cart.item_count) {
      hideRecs();
    }
  }

})();
